import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import {of as observableOf,  Observable } from 'rxjs';
import {catchError} from 'rxjs/operators';
import { ErrorResponse, SuccessResponse } from '@shared/services/api/response';
import { UserProvisioningType } from '@shared/enums/UserProvisioningType';
import { IGetUserProvisioning, IUpdateUserProvisioning, IUserProvisioning } from './user-provsionings-model';

@Injectable()
export class UserProvisioningsService {

    constructor(private http: HttpClient) { }

    private static get URL(): string { return `${environment.dashboardApi.baseUrl}${environment.dashboardApi.prefix}`; }
    private static readonly ENDPOINT = 'userprovisionings';

    /** GET */
    public getProvisioningByType(type: UserProvisioningType): Observable<SuccessResponse<IUserProvisioning> | ErrorResponse>  {
        return this.http
            .get<SuccessResponse<IUserProvisioning>>(
                UserProvisioningsService.URL +
                UserProvisioningsService.ENDPOINT + '/' + type
            ).pipe(
            catchError(x => observableOf(new ErrorResponse(x?.error?.messages))));
    }

    /** GET */
    public getProvisioning(): Observable<SuccessResponse<IGetUserProvisioning> | ErrorResponse>  {
        return this.http
            .get<SuccessResponse<IUserProvisioning>>(
                UserProvisioningsService.URL +
                UserProvisioningsService.ENDPOINT
            ).pipe(
            catchError(x => observableOf(new ErrorResponse(x?.error?.messages))));
    }

    public generateAccessToken(): Observable<SuccessResponse<string> | ErrorResponse> {
            return this.http
                .post<SuccessResponse<string>>(
                    UserProvisioningsService.URL +
                    UserProvisioningsService.ENDPOINT +
                    '/generates', { }).pipe(
                catchError(x => observableOf(new ErrorResponse(x?.error?.messages))));
        }

    public updateUserProvisioning(userProvisioning: IUpdateUserProvisioning): Observable<SuccessResponse<boolean> | ErrorResponse> {
         return this.http
                    .put<SuccessResponse<boolean>>(
                        UserProvisioningsService.URL +
                        UserProvisioningsService.ENDPOINT, userProvisioning).pipe(
                    catchError(error => observableOf(new ErrorResponse(error.error.messages))));
    }

    public deleteProvisioning(): Observable<SuccessResponse<boolean> | ErrorResponse>  {
        return this.http
        .delete<SuccessResponse<boolean>>(
            UserProvisioningsService.URL +
            UserProvisioningsService.ENDPOINT,
        ).pipe(
        catchError(x => observableOf(new ErrorResponse(x?.error?.messages))));
    }

}
